import { AudioPlayerButton, SongWaveform } from 'components';
import { AnalyticsEventLocation } from 'services/analytics/entities';
import { toColonTimeFromMs } from 'services/helpers/time';
import { Song } from 'services/store/songs/types';
import ActionButtons from './components/ActionButtons';
import MobileActionButtons from './components/MobileActionButtons';
import {
  Container,
  DurationContainer,
  DurationText,
  PlayerContainer,
  SeekbarContainer,
  SongActionsContainer,
  SongTitle,
  StyledListItem,
  SongTitleAndArtistNameContainer,
  WaveformContainer,
} from './styled';

type PropsType = {
  song: Song;
};
const StudioSongItem = ({ song }: PropsType) => {
  const eventLocation = AnalyticsEventLocation.LIBRARY;

  return (
    <StyledListItem>
      <Container>
        <PlayerContainer>
          <AudioPlayerButton song={song} location={eventLocation} />
          <SongTitleAndArtistNameContainer>
            <SongTitle>{song.title}</SongTitle>
          </SongTitleAndArtistNameContainer>
        </PlayerContainer>
        <SeekbarContainer>
          <WaveformContainer>
            <SongWaveform song={song} />
          </WaveformContainer>
          <DurationContainer>
            <DurationText variant="body1">
              {toColonTimeFromMs(song?.duration)}
            </DurationText>
          </DurationContainer>
        </SeekbarContainer>
        <SongActionsContainer>
          <ActionButtons song={song} />
          <MobileActionButtons song={song} />
        </SongActionsContainer>
      </Container>
    </StyledListItem>
  );
};

export default StudioSongItem;
